import 'react-native-gesture-handler';
import * as React from 'react';
import {AppRegistry} from 'react-native';
import {GestureHandlerRootView} from 'react-native-gesture-handler';
import {MenuProvider} from 'react-native-popup-menu';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import {PaperProvider} from 'react-native-paper';

import App from './src/components/App';
import Settings from './src/Settings';
import {persistor, store} from './src/redux/store';
import {PaperTheme} from './src/components/PaperTheme';
import {IntlProvider} from 'react-intl';

// Load localization data
const fallbackLocale = 'en-US';

if (typeof window !== 'undefined') {
  window.addEventListener('DOMContentLoaded', () => {
    console.log(' OneSignal App ID:', Settings.oneSignalAppId);

    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(function (OneSignal) {
      console.log(' Initializing OneSignal...');
      OneSignal.init({
        appId: Settings.oneSignalAppId,
        serviceWorkerPath: '/OneSignalSDKWorker.js',
        serviceWorkerParam: { scope: '/' },
      })
        .then(() => console.log(' OneSignal initialized'))
        .catch((err) => console.error(' OneSignal init failed:', err));
    });


    const style = document.createElement('style');
    style.innerHTML = `
      body > iframe {
        pointer-events: none !important;
        z-index: 0 !important;
      }
    `;
    document.head.appendChild(style);
  });
}


AppRegistry.registerComponent('App', () => () => {
  const [loaded, error] = require('expo-font').useFonts({
    'Aeonik-Regular': require('./assets/fonts/Aeonik/static/Aeonik-Regular.otf'),
    'Figtree-Regular': require('./assets/fonts/Figtree/static/Figtree-Regular.ttf'),
    'Poppins-Regular': require('./assets/fonts/Poppins/static/Poppins-Regular.ttf'),
    'Roboto-Regular': require('./assets/fonts/Roboto/static/Roboto-Regular.ttf'),
    'Comodo-Vintage': require('./assets/fonts/Comodo/static/Comodo-Vintage.otf'),
  });

  const locale = Settings.getLocale();
  if (!loaded && !error) return null;

  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <IntlProvider
              locale={locale}
              defaultLocale={fallbackLocale}
            >
            <MenuProvider>
              <PaperProvider theme={PaperTheme}>
                <App />
              </PaperProvider>
            </MenuProvider>
            </IntlProvider>
        </PersistGate>
      </Provider>
    </GestureHandlerRootView>
  );
});


AppRegistry.runApplication('App', {
  rootTag: document.getElementById('root'),
});
